import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import * as controller from '../controller'
import { withLocalize } from "react-localize-redux";

class Categories extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      categories: []
    }
  }


  loadCategories() {
    fetch('categories/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let categories = data.categories
        this.setState({categories})
    }).catch(err => {
      //alert(err.message);
    })
  }

  componentWillMount() {
    //Only users can see this page
    if(window.account.type != "admin")
      this.props.history.push("/login/admin")


    this.loadCategories()
  }



  public render() {
    const columns = [{
      Header: '#',
      accessor: 'id',
      maxWidth: 80,
      resizable: false
    }, {
      Header: this.props.translate("name").toString(),
      accessor: 'title'
    }, {
      id: 'settings',
      Header: this.props.translate("settings").toString(),
      sortable: false,
      maxWidth: 140,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/users/categories/" + row.value.id}><i className="fas fa-edit"></i></Link>
        <Link to={"/users?category="+row.value.id}><i className="fas fa-users"></i></Link>
        <i onClick={controller.removeCategory.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>
      </div>
    }]

    return (
      <div id="users-root">
        <div className="board">
          <ReactTable
            data={this.state.categories}
            columns={columns}
            defaultPageSize={10}
            noDataText={this.props.translate("noResults").toString()}
            nextText={this.props.translate("next").toString()}
            previousText={this.props.translate("previous").toString()}
            rowsText={this.props.translate("rows").toString()}
            pageText={this.props.translate("page").toString()}
            ofText={this.props.translate("of").toString()}
            style={{
              height: "400px",
              textAlign: "center",
              fontSize: "1em",
              position: "centner",
              right: "0",
              left: "0",
              margin: "0 auto"
            }}
            className="-striped -highlight reactTable"
          />
        </div>
      </div>
    )
  }

}

export default withLocalize(Categories)



// WEBPACK FOOTER //
// ./src/pages/user/categories/Categories.tsx